import { useState, useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import getSteps from '~/sale/constants/steps'
import { Steps, Step, Status } from '~/sale/model/sale.model'
import { selectIsPostpaid } from '~/sale/store/sale.selectors'

interface useStepperReturn {
  activeStep: Step
  steps: Steps
}

export default function useStepper(): useStepperReturn {
  const location = useLocation()
  const isPostPaid = useSelector(selectIsPostpaid)
  const steps = getSteps(isPostPaid)
  const [activeStep, setActiveStep] = useState(steps.SALES)
  useEffect(() => {
    const actualStep =
      Object.keys(steps).find((step) => steps[step].path === location.pathname) || 'SALES'
    setActiveStep(steps[actualStep])
  }, [location])

  const allSteps = useMemo(() => {
    const allStepsKeys = Object.keys(steps)
    allStepsKeys.forEach((step) => {
      if (steps[step].number < activeStep.number || allStepsKeys.length - 1 === activeStep.number)
        steps[step].status = Status.COMPLETED
      if (steps[step].number === activeStep.number && allStepsKeys.length - 1 !== activeStep.number)
        steps[step].status = Status.ACTIVE
      if (steps[step].number === activeStep.number + 1) steps[step].status = Status.ENABLED
      if (steps[step].number > activeStep.number + 1) steps[step].status = Status.DISABLED
    })
    return steps
  }, [activeStep, isPostPaid])

  return {
    activeStep,
    steps: allSteps,
  }
}
